import { render, staticRenderFns } from "./WriteoffList.vue?vue&type=template&id=53a373f2&"
import script from "./WriteoffList.vue?vue&type=script&lang=js&"
export * from "./WriteoffList.vue?vue&type=script&lang=js&"
import style0 from "./WriteoffList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports